<script>
    export let text;
</script>

<style>
    p {
        background-color: var(--color-primary-variant);
        color: var(--color-secondary);
        padding: .37em 1.2em .3em;
        margin: 0 0 1em;
        font-size: 1.7em;
        text-align: center;
    }
</style>

<p id="info-text">
	{text}
</p>